import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import ReactGa from 'react-ga4';
import { authAction, authSelector } from '../features/auth/slice';

function buildMenuHierarchy(itemsData, userAdminYn, userSuperAdminYn) {
  const map = new Map();
  const roots = [];

  itemsData.forEach((item) => {
    map.set(item.id, { ...item, items: [] });
  });

  itemsData.forEach((item) => {
    const currentItem = map.get(item.id);

    // superAdmin 전용 메뉴: superAdminYn='Y'인 사용자만
    if (currentItem.superAdminYn === 'Y' && userSuperAdminYn !== 'Y') return;

    if (
      (currentItem.adminYn === 'Y' && userAdminYn !== 'Y') ||
      (currentItem.adminYn === 'N' && userAdminYn === 'Y')
    ) {
      return;
    }

    if (item.parentId === null) {
      roots.push(currentItem);
    } else {
      const parent = map.get(item.parentId);
      if (parent) {
        parent.items.push(currentItem);
      }
    }
  });

  return roots.sort((a, b) => a.order - b.order);
}

export default function useAuthInit() {
  const { me, menuItems } = useSelector(authSelector.selectAuthState);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(!me && !!localStorage.getItem('token'));

  useEffect(() => {
    if (me) {
      ReactGa.set({ user_id: me.id });
      ReactGa.event('user_info', { user_name: me.name });
      return;
    }

    const token = localStorage.getItem('token');
    if (token) {
      dispatch(authAction.setLoading(true));
      setLoading(true);
      axios
        .get('/auth/me')
        .then((res) => {
          ReactGa.set({ user_id: res.data.id });
          ReactGa.event('user_name', { user_name: res.data.name });
          dispatch(authAction.changeMe(res.data));
          // 다음 방문/새로고침 시 테마 깜빡임 방지를 위해 hostname별 캐시 저장
          try {
            const cacheKey = `dist_info_${window.location.hostname}`;
            localStorage.setItem(cacheKey, JSON.stringify({
              distributorId: res.data.distributorId,
              distributorTheme: res.data.distributorTheme,
              distributorName: res.data.distributorName,
              distributorLogo: res.data.distributorLogo,
              distributorBusinessNumber: res.data.distributorBusinessNumber,
              distributorRepresentative: res.data.distributorRepresentative,
              distributorAddress: res.data.distributorAddress,
            }));
          } catch {}
        })
        .finally(() => {
          dispatch(authAction.setLoading(false));
          setLoading(false);
        });
    }
  }, [dispatch, me]);

  useEffect(() => {
    if (menuItems && menuItems.length > 0) return;

    if (me && me.userType === 'client') {
      axios
        .get(`${process.env.REACT_APP_API_URL}/permission`, {
          withCredentials: true,
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
        .then((res) => {
          const rawItems = res.data;
          const hierarchicalItems = buildMenuHierarchy(rawItems, me.adminYn, me.superAdminYn);
          dispatch(authAction.changeMenuItems(hierarchicalItems));
        })
        .catch((error) => {
          console.error('메뉴 데이터를 오류:', error);
          dispatch(authAction.changeMenuItems([]));
        });
    }
  }, [me, menuItems, dispatch]);

  return { loading };
}
